"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SKIN = {
    general: 'general',
    standard: 'standard',
    danger: 'danger',
    success: 'success',
    neutral: 'neutral',
    neutralLight: 'neutralLight',
    warning: 'warning',
    warningLight: 'warningLight',
    urgent: 'urgent',
    neutralStandard: 'neutralStandard',
    neutralSuccess: 'neutralSuccess',
    neutralDanger: 'neutralDanger',
    premium: 'premium',
};
exports.TYPE = {
    solid: 'solid',
    outlined: 'outlined',
    transparent: 'transparent'
};
exports.SIZE = {
    medium: 'medium',
    small: 'small'
};
//# sourceMappingURL=constants.js.map